import AxiosService from "@/services/AxiosService";
import IBrandServiceShop from "@/services/definition/IBrandServiceShop";
import {IBrandShopListEntry} from "@/models/brand/BrandShopModels";
import Vue from "vue";

export default class AxiosBrandServiceShop extends AxiosService implements IBrandServiceShop {

	public static readonly BASE_URL = '/Shop/brands';
	public static readonly BASE_URL_COMMON = '/brands';

	protected defineBaseUrl(): string {
		return AxiosBrandServiceShop.BASE_URL;
	}

	public brands(): Promise<IBrandShopListEntry[]> {
		return Vue.$axios.get<IBrandShopListEntry[]>(this.url()).then(res => res.data);
	}
}
